export const testWordComparison = (transcript: string, targetWord: string): boolean => {
  const cleanTranscript = transcript.toLowerCase().trim();
  const cleanTarget = targetWord.toLowerCase().trim();
  return cleanTranscript.includes(cleanTarget);
}; 